import { HelpMessage, IMsg } from '../common/interfaces';

export abstract class ITrackService {
  abstract event(eventName: string, props?: any): void;
  abstract handleHelpMessage(message: HelpMessage): void;
  abstract handleToast(toast: IMsg): void;
}
